import { apiSlice } from '@/api/api.slice';
import { AccountsSlice } from '@/features/accounts/accounts.slice';
import { loginSlice } from '@/features/login/login.slice';
import { meansOfPaymentsSlice } from '@/features/means-of-payments/MeansOfPayments.slice.ts';
import onBoardingSlice from '@/features/OnBoarding/OnBoarding.slice.ts';
import { TutorialSlice } from '@/features/Tutorial/Tutorial.slice.ts';
import {
  combineReducers,
  configureStore,
  createAction,
  UnknownAction,
} from '@reduxjs/toolkit';
import { ApplicationSlice } from './Application.slice.ts';

const rootReducer = combineReducers({
  applicationContext: ApplicationSlice.reducer,
  tutorial: TutorialSlice.reducer,
  login: loginSlice.reducer,
  onBoarding: onBoardingSlice.reducer,
  accounts: AccountsSlice.reducer,
  meansOfPayments: meansOfPaymentsSlice.reducer,

  // Api slice
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const ACTION_LOGOUT = createAction('root/logout');

const hydratedReducer = (
  state: RootState | undefined,
  action: UnknownAction,
): RootState => {
  if (ACTION_LOGOUT.match(action)) {
    // reset the state to the initial state
    return rootReducer(undefined, action);
  }

  // call the reducer normally
  const nextState = rootReducer(state, action);
  // otherwise don't do anything
  return nextState;
};

export const store = configureStore({
  reducer: hydratedReducer,
  devTools:
    import.meta.env.MODE !== 'production' ?
      {
        actionCreators: {
          ...ApplicationSlice.actions,
          ...TutorialSlice.actions,
          ...loginSlice.actions,
          ...onBoardingSlice.actions,
          ...AccountsSlice.actions,
          ACTION_LOGOUT,
        },
      }
    : false,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['onBoarding/setFile', 'onBoarding/file'],
        ignoredPaths: ['onBoarding.file'],
      },
    }).concat(apiSlice.middleware),
});

export type AppDispatch = typeof store.dispatch;
